import React from "react";
import BlockContent from "@sanity/block-content-to-react";
import { urlFor } from "../../../../services/client";
import styles from "./LearningPlayer.module.css";

function makeSerializers({ fontSize }) {
  return {
    types: {
      image: ({ node }) => (
        <img
          src={urlFor(node.asset).width(1100).url()}
          alt={node.alt || ""}
          className={styles.bodyImage}
        />
      ),
    },
    list: ({ children }) => <ol className={styles.bodyList}>{children}</ol>,
    listItem: ({ children }) => (
      <li className={styles.bodyListItem}>
        <span className={styles.bodyListIndex} />
        <span className={styles.bodyListBody}>{children}</span>
      </li>
    ),
    block: ({ node, children }) => {
      const style = node.style || "normal";
      if (style === "blockquote") {
        return (
          <p
            className={styles.bodyPullquote}
            style={{ fontSize: fontSize * 1.55 }}
          >
            "{children}"
          </p>
        );
      }
      if (style === "h1" || style === "h2") {
        return (
          <h2 className={`${styles.bodyHeading} ${styles.bodyH2}`}>
            {children}
          </h2>
        );
      }
      if (style === "h3") {
        return (
          <h3 className={`${styles.bodyHeading} ${styles.bodyH3}`}>
            {children}
          </h3>
        );
      }
      if (style === "h4") {
        return (
          <h4 className={`${styles.bodyHeading} ${styles.bodyH4}`}>
            {children}
          </h4>
        );
      }
      return <p className={styles.bodyP}>{children}</p>;
    },
  };
}

export default function InformationalStep({ blocks, fontSize }) {
  const serializers = makeSerializers({ fontSize });
  return (
    <div className={styles.bodyCopy} style={{ fontSize }}>
      <BlockContent blocks={blocks} serializers={serializers} />
    </div>
  );
}
